/*
 * @Descripttion:
 * @version:
 * @Author: sueRimn
 * @Date: 2021-11-18 19:35:59
 * @LastEditors: sueRimn
 * @LastEditTime: 2021-12-01 14:13:59
 */

// 后端语种与element国际化的对应map
export const LANG_ELEMENT_MAP = {
  CN: "zh-cn", // 中文
  EN: "en", // 英语
  TH: "th", // 泰语
  KH: "kh", // 柬埔寨(暂无)
  MY: "my", // 马来语(暂无)
  ID: "id", // 印尼语
  VN: "vi" // 越南语
};

// 请求超时时间 15s
export const TIMEOUT_TIMES = 15000;

// 接口等待时间 1000ms INTW_TIMES-> interface waiting times
export const INTW_TIMES = 1000;

// 接口等待开关状态
export const INTW_SWITCH = true;

// 请求成功
export const RESPONSE_SUCCESS = 1;

// baseEnv
export const BASE_ENV = () => {
  const baseEnv = process.env.NODE_ENV;
  let secretKey = ""; // 密码加密密钥
  let signKey = ""; // 验签密钥
  if (baseEnv === "development" || baseEnv === "test") {
    secretKey = "f3755443b85115ba";
    signKey = "3d19c7d52ca8e113";
  } else if (baseEnv === "uat") {
    secretKey = "92f02473aa24075f";
    signKey = "90q2add9bfb2ll8c";
  } else if (baseEnv === "production") {
    secretKey = "92f02473aa24075f";
    signKey = "3aqdaed70bb7l84l";
  }
  return { secretKey, signKey };
};
